import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-product-comment",
  "use": "icon-product-comment-usage",
  "viewBox": "0 0 1045 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1045 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-product-comment\"><path d=\"M1031.975 202.254l-530.51 551.727H308.592V561.11l532.44-549.798c15.082-15.082 39.5-15.082 54.582 0l136.36 136.36c15.083 15.082 15.083 39.5 0 54.582zM868.305 93.128L385.742 599.684v77.148h77.148l487.27-501.85-81.855-81.854zM540.039 98.18H77.149v848.632H925.78v-462.89c0-27.966 8.178-33.752 36.144-33.752 28.005 0 41.005 5.786 41.005 33.752v462.89c0 37.263-39.886 77.148-77.149 77.148H77.148C39.886 1023.961 0 984.076 0 946.813V98.181C0 60.88 39.886 21.033 77.148 21.033h462.89c27.967 0 33.753 13.038 33.753 41.004 0 27.928-5.786 36.144-33.752 36.144z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/product-comment.svg
// module id = b5pz
// module chunks = 78